<div class="msa-ol">
  <div class="msa-ol__count-card msa-ol__count-card--{{ layout() }}" [class]="'msa-ol__count-card--' + countVariant()">
    @if (layout() === 'inline') {
      <span class="msa-ol__count-label">
        {{ title() }}: <span class="msa-ol__count-value msa-ol__count-value--inline">{{ count() }}</span>
      </span>
    } @else {
      <span class="msa-ol__count-label">{{ title() }}</span>
      <span class="msa-ol__count-value">{{ count() }}</span>
    }
  </div>

  <div class="msa-ol__list">
    @if (items().length === 0) {
      <p class="msa-ol__empty">{{ emptyMessage() }}</p>
    }
    @for (item of items(); track item.key) {
      <div class="msa-ol__row" [class.msa-ol__row--highlighted]="item.highlighted">
        <span class="msa-ol__date">{{ item.dateLabel }}</span>
        <span class="msa-ol__time">{{ item.timeLabel }}</span>
        <lib-badge [label]="item.badgeLabel" [color]="item.badgeColor" size="sm" />
      </div>
    }
  </div>
</div>
